
classColorizeImage = function(color) {

    var self = this;

    this.color = color;

    this.colors = {
        'black': [0, 0, 0],
        'red': [185, -35, -25],
        'green': [26, 119, -17],
        'blue': [-35, 52, 122],
        'purple': [43, -35, 116],
        'brown': [133, 37, -35],
        'yellow': [179, 111, -30],
        'orange': [193, 37, -35]
    };

    this.getAnimationImage = function(img) {

        if (img.complete) {
            // create temporary canvas if doesn't exist
            var canvasTemp = document.getElementById('canvasTemp');
            if (null === canvasTemp) {
                var canvasTemp = document.createElement('canvas');
                canvasTemp.id = 'canvasTemp';
                canvasTemp.style.display = 'none';
                document.body.appendChild(canvasTemp);
            }

            // create Image object and attach source
            var img = img;

            // adjust canvas dimensions
            canvasTemp.width = img.width;
            canvasTemp.height = img.height;

            var contextTemp = canvasTemp.getContext("2d");
            contextTemp.clearRect(0, 0, canvasTemp.width, canvasTemp.height);

            try {
                contextTemp.drawImage(img, 0, 0);
                var imageData = contextTemp.getImageData(0, 0, canvasTemp.width, canvasTemp.height);
                for (pixel = 0; pixel < imageData.data.length; pixel += 4) {

                    if (imageData.data[pixel + 3] > 0) {

                        if (imageData.data[pixel] == 255 && imageData.data[pixel + 1] == 255 && imageData.data[pixel + 2] == 255) {

                        } else {

                            imageData.data[pixel] = imageData.data[pixel] + (self.colors[self.color][0]);
                            imageData.data[pixel + 1] = imageData.data[pixel + 1] + (self.colors[self.color][1]);
                            imageData.data[pixel + 2] = imageData.data[pixel + 2] + (self.colors[self.color][2]);
                            imageData.data[pixel + 3] = 255;
                        }
                    }
                }

                contextTemp.putImageData(imageData, 0, 0);
                image = new Image();
                image.src = canvasTemp.toDataURL();

            } catch (error) {}

            return image;

        } else {
            setTimeout(self.getAnimationImage(img), 2000);
        }
    }

}

classBalls = function(type) {

    this.capitalize = function(str) {
        strVal = '';
        str = str.split('');
        for (var chr = 0; chr < str.length; chr++) {
            strVal += str[chr].substring(0, 1).toUpperCase() + str[chr].substring(1, str[chr].length) + ' '
        }
        return strVal
    }

    var self = this;

    this.colors = {
        'red': [1, 9, 17, 25, 33, 41],
        'green': [2, 10, 18, 26, 34, 42],
        'blue': [3, 11, 19, 27, 35, 43],
        'purple': [4, 12, 20, 28, 36, 44],
        'brown': [5, 13, 21, 29, 37, 45],
        'yellow': [6, 14, 22, 30, 38, 46],
        'orange': [7, 15, 23, 31, 39, 47],
        'black': [8, 16, 24, 32, 40, 48]
    };

    this.getColor = function(number) {
        for (var key in self.colors) {
            if (self.colors[key].indexOf(number) >= 0) {
                return key;
            }
        }
    }

    // create class properties (image objects)
    for (var color in this.colors) {
        switch (type) {
            case "small":
                // Notice this[color] !
                this[color] = new classImage(images['drawn_ball_' + color]);
                break;

            case "big":
                this[color] = new classImage()
                        .setX(250)
                        .setY(56)
                        .setWidth(230)
                        .setHeight(235)
                        .setAnimation({
                            show: false,
                            stop: true,
                            sequences: images['big_ball_' + color],
                            slowMotion: false
                        });
                break;
            default:
        }

    }

}

classSmallBalls = function(ballNumber, x, y, size) {

    var self = this;

    this.textColors = {
        "brown": "#3b2100",
        "black": "#000000",
        "red": "#a50a00",
        "purple": "#2d0077",
        "orange": "#a54600",
        "blue": "#003155",
        "yellow": "#755800",
        "green": "#264200"
    }

    this.x = x;
    this.y = y;
    this.size = size;
    this.ballNumber = ballNumber;
    this.fadeIn = 1;
    this.fadeInX = this.x + (this.size / 2);
    this.fadeInY = this.y + (this.size / 2);
    this.balls = new classBalls('small');
    self.color = self.balls.getColor(self.ballNumber);

    this.fontSize = 1;
    this.textX = (this.ballNumber > 9) ? this.fadeInX - 6 : this.fadeInX - 3;
    this.textY = this.fadeInY + 4;

    this.drawer = new function() {

        this.draw = function() {

            try {
                var ballNo = self.ballNumber;
                var ball = self.balls.getColor(ballNo);

                self.balls[ball].setX(self.fadeInX).setY(self.fadeInY);
                self.balls[ball].setWidth(self.fadeIn).setHeight(self.fadeIn);

                self.balls[ball].drawer.draw();
                self.animateNumber();
            } catch (error) {
                console.log(error)
            }
        }

    }

    this.animateNumber = function() {

        var color = self.balls.getColor(self.ballNumber);

        if (self.fontSize > 8) {
            context.save();
            context.fillStyle = self.textColors[color];
            context.font = "bold " + self.fontSize + "px EurostileBold"
            context.fillText(self.ballNumber, self.textX, self.textY);
            context.restore();
        }
    }

    this.hookAfterDraw = function() {

        if (self.fontSize < 11) {
            self.fontSize = self.fontSize + 0.5;
        }

        if (self.fadeIn < self.size - 18) {
            self.fadeIn = self.fadeIn + 2;
        }

        if (self.fadeInX > self.x + 9) {
            self.fadeInX = self.fadeInX - 2;
        }

        if (self.fadeInY > self.y + 9) {
            self.fadeInY = self.fadeInY - 2;
        }
    }

}

classBigBall = function() {

    var self = this;

    this.ball = false;
    this.balls = new classBalls('big');

    this.textColors = {
        "brown": "#3b2100",
        "black": "#000000",
        "red": "#a50a00",
        "purple": "#2d0077",
        "orange": "#a54600",
        "blue": "#003155",
        "yellow": "#755800",
        "green": "#264200"
    }


    this.setBall = function(ballNumber) {
        self.ballNumber = ballNumber;
        self.color = self.balls.getColor(self.ballNumber);
        self.ball = self.balls[self.color];
    }

    self.showDrawnBall = false;
    self.run = false;

    this.startAnimation = function() {
        self.ball.startAnimation();
        self.showDrawnBall = true;
        self.run = true;
    }

    this.drawer = new function() {
        this.draw = function() {
            if (self.run) {
                self.ball.drawer.animate();
                self.animateNumber();
            }
        };
    }

    this.hookAfterDraw = function() {
        if(self.ball !== false) {
            if (self.ball.drawer.sequenceNo == self.ball.animation.sequences.length - 1 && self.showDrawnBall === true) {
                self.ball.stopAnimation();
                self.showDrawnBall = false;
            }
        }
    }

    this.animateNumber = function() {
        context.fillStyle = self.balls.getColor(self.ballNumber);
        var fontFamily = 'EurostileBold';

        switch (self.ball.drawer.sequenceNo) {
            case 11:
                var fontSize = 52;
                var x = 200;
                var y = 190;
                var w = 56;
                var textX = (self.ballNumber > 9) ? 214 : 242;
                var textY = 228;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                // context.fillRect(x, y, w, fontSize); // debug
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                // self.ball.stopAnimation(); // debug
                context.restore();
                break;

            case 12:
                var fontSize = 62;
                var x = 200;
                var y = 170;
                var w = 56;
                var textX = (self.ballNumber > 9) ? 222 : 251;
                var textY = 219;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;

            case 13:
                var fontSize = 62;
                var x = 200;
                var y = 155;
                var w = 53;
                var textX = (self.ballNumber > 9) ? 242 : 265;
                var textY = 210;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;

            case 14:
                var fontSize = 62;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 260 : 282;
                var textY = 198;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;

            case 15:
                var fontSize = 62;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 275 : 296;
                var textY = 193;
                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;

            case 16:
                var fontSize = 66;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 288 : 308;
                var textY = 189;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;
            case 17:

                var fontSize = 68;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 299 : 321;
                var textY = 186;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);

                context.restore();
                break;

            case 18:
                var fontSize = 72;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 308 : 331;
                var textY = 185;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;

            case 19:
                var fontSize = 72;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 317 : 342;
                var textY = 185;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;

            case 20:
                var fontSize = 76;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 320 : 345;
                var textY = 187;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;

            case 21:
                var fontSize = 76;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 323 : 348;
                var textY = 187;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);

                context.restore();
                break;

            case 22:
                var fontSize = 76;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 325 : 349;
                var textY = 187;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;
            case 23:

                var fontSize = 76;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 326 : 351;
                var textY = 187;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;

            case 24:
                var fontSize = 76;
                var x = 205;
                var y = 149;
                var w = 60;
                var textX = (self.ballNumber > 9) ? 326 : 352;
                var textY = 187;

                context.save();
                context.font = fontSize + 'px ' + fontFamily;
                var screenWithoutNumber = context.getImageData(x, y, w, fontSize);
                context.fillText(self.ballNumber, textX, textY);
                context.putImageData(screenWithoutNumber, x, y);
                context.restore();
                break;
            default:
        }
    }

}


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/balls.js
// module id = 842
// module chunks = 2